import { render, staticRenderFns } from "./PerfQueryCRM.vue?vue&type=template&id=0587c9db&scoped=true"
import script from "./PerfQueryCRM.vue?vue&type=script&lang=js"
export * from "./PerfQueryCRM.vue?vue&type=script&lang=js"
import style0 from "./PerfQueryCRM.vue?vue&type=style&index=0&id=0587c9db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0587c9db",
  null
  
)

export default component.exports